export function roundDate (timeStamp) {
  var d = new Date(timeStamp)
  var msSinceMidnight = d.getTime() - d.setHours(0, 0, 0, 0)
  timeStamp = timeStamp - msSinceMidnight
  var cstOffset = (3600000 * (5))
  var localOffset = (-1) * d.getTimezoneOffset() * 60000
  var timeStamp2 = timeStamp + cstOffset + localOffset
  return timeStamp2
}
var today = roundDate(new Date(new Date().setDate(new Date().getDate())))
var yesterday = roundDate(new Date(new Date().setDate(new Date().getDate() - 1)))
var twoDaysAgo = roundDate(new Date(new Date().setDate(new Date().getDate() - 2)))

export default {
  today: today,
  yesterday: yesterday,
  twoDaysAgo: twoDaysAgo
}



// WEBPACK FOOTER //
// ./src/components/date-utils.js